import types from './types'

// Product Detail Fetch
export const searchData = (payload) => ({
  type: types.SEARCH, payload
})
export const searchResponse = (payload) => ({
  type: types.SEARCH_RESPONSE, payload
})
export const searchClear = () => ({ type: types.SEARCH_CLEAR })